import React from "react";

const Spinner = ({ className }) => {
  return (
    <div className="w-100 d-flex justify-content-center align-items-center">
      <div
        class={`spinner-border loader ${
          className ? className : "text-primary"
        }`}
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Spinner;
